<main>
    <div class="page-breadcrumb d-md-flex align-items-center justify-content-between">
        <h2 class="page-title">Transaction</h2>
        <!-- <app-breadcrumb></app-breadcrumb> -->
        <div class="breadcrumbWidget">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a routerLink="/dashboard">Dashboard</a></li>
              <li class="breadcrumb-item"><a routerLink="/transactions">Transactions</a></li>
              <li class="breadcrumb-item active" aria-current="page">Transaction details</li>
            </ol>
        </div>
    </div>

    <div class="container-fluid">
        <div class="matCard">
            <div class="matCrdTitle centerItemVert justify-content-between">
                <h3 class="matCardTitle">Payment details</h3>
                <a routerLink="/transactions" class="btn btn-primary btnsmall">Back</a>
            </div>
            
            <div class="matCardBody">
                <div class="profileDetailsWidget pt-4 d-md-flex">
                    <!-- <div class="profilePicLeft form-group30">
                        <p class="chngePic">
                            <input type="file">
                            <span class="icon centerItem"><mat-icon>edit</mat-icon></span>
                            <img src="../../../assets/img/display.jpg" alt="">
                        </p>
                    </div> -->
                    <div class="profileContentRight flex-grow-1">
                        <div class="proSection">
                            <div class="row">
                                <div class="col s12 m6 form-group">
                                <div class="row">
                                    <div class="col s12 m12 form-group">
                                        <div class="detailsContent">
                                            <label>Transaction Id  :</label>
                                            <span>{{transactionID}}</span>
                                        </div>
                                    </div>
                                   
                                </div>
                                <div class="row">
                                    <div class="col s12 m12 form-group">
                                        <div class="detailsContent">
                                            <label>Payment Date :</label>
                                            <span>{{createdDate | date:'dd-MM-yyyy'}}</span>
                                        </div>
                                    </div>
                                  
                                </div>
                               
                                <div class="row">
                                    <div class="col s12 m12 form-group">
                                        <div class="detailsContent">
                                            <label>Amount :</label>
                                            <span>$ {{amount}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col s12 m12 form-group">
                                        <div class="detailsContent">
                                            <label>Customer Name :</label>
                                            <span>{{payerName}}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col s12 m12 form-group">
                                        <div class="detailsContent">
                                            <label>Paid For :</label>
                                        <span>{{organizationName}}</span>
                                        </div>
                                    </div>
                                </div>
                                </div>
                                <div class="col s12 m6 form-group">
                                    <div class="row">
                                        <div class="col s12 m12 form-group">
                                            <div class="detailsContent">
                                                <label>Payment Method :</label>
                                            <span>{{paymentMethod}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col s12 m12 form-group">
                                            <div class="detailsContent">
                                                <label>Plan Type :</label>
                                            <span>{{planType}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col s12 m12 form-group">
                                            <div class="detailsContent">
                                                <label>Invoice Number :</label>
                                            <span>{{invoiceNumber}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <hr>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>
